import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { PageNavigationComponent } from './page-navigation/page-navigation.component';
import { SearchComponent } from './search/search.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogsModule } from './dialogs/dialogs.module';
import { SharedModule } from './shared/shared.module';
import { ButtonsModule } from './buttons/buttons.module';
import { ThumbnailModule } from './thumbnail/thumbnail.module';
import { DatesModule } from './dates/dates.module';
import { HandlesModule } from './handles/handles.module';
import { TabsModule } from './tabs/tabs.module';
import { FormsModule } from './forms/forms.module';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CommentModule } from './comment/comment.module';
import { MenuModule } from './menu/menu.module';
import { LinkAccessModule } from './link-access/link-access.module';
import { MoreInfoModule } from './more-info/more-info.module';

@NgModule({
  declarations: [
    SearchComponent,
    PageNavigationComponent,
    TextEditorComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    DialogsModule,
    SharedModule,
    ButtonsModule,
    ThumbnailModule,
    DatesModule,
    HandlesModule,
    TabsModule,
    FormsModule,
    CommentModule,
    MenuModule,
    LinkAccessModule,
    TypeaheadModule.forRoot(),
    MoreInfoModule
  ],
  exports: [
    SearchComponent,
    PageNavigationComponent,
    TextEditorComponent,
    CommonModule,
    DialogsModule,
    SharedModule,
    ButtonsModule,
    DatesModule,
    ThumbnailModule,
    HandlesModule,
    TabsModule,
    FormsModule,
    CommentModule,
    LinkAccessModule,
    MenuModule,
    MoreInfoModule
  ]
})
export class RlCommonModule {}
